import { PointerEventTypes, PointerInfo } from '@babylonjs/core/Events/pointerEvents'

import { MeshPoints } from '../meshPoints/meshPoints.tool'
import { BabylonToolConfig, MouseButtonCodes } from '../../../../../types'

export class Measure extends MeshPoints {
    static NAME = 'MEASURE'

    constructor(config: BabylonToolConfig) {
        super(config)
        this.name = Measure.NAME
    }

    /**
     * Handle pointer observable event and emit the correct
     * events on measurement points change
     * @param evt pointer observable event
     * @returns
     */
    protected selectPoint = (evt: PointerInfo) => {
        if (evt.type !== PointerEventTypes.POINTERDOWN) return
        const pick = this.pickWithRayPicker()
        const leftClicked = evt.event.button === MouseButtonCodes.Left
        const hitAMesh = pick && pick.hit

        if (!leftClicked) return

        if (!hitAMesh) {
            this.clearMeasurements()

            return
        }

        if (this.meshPoints.length < 2) {
            if (pick && pick.pickedPoint) {
                this.meshPoints.push(pick.pickedPoint)
                this.mediator.mediate('3D', {
                    meshPoints: this.meshPoints.map((vector) => {
                        return { x: vector.x, y: vector.y, z: vector.z }
                    }),
                })
            }
        } else {
            this.clearMeasurements()
        }

        if (this.meshPoints.length === 2) {
            const measurement = this.meshPoints[0].subtract(this.meshPoints[1]).length()

            this.mediator.mediate('tools', { measurement })
        }
    }

    private clearMeasurements = () => {
        this.meshPoints = []
        this.mediator.mediate('3D', { meshPoints: null }).mediate('tools', { measurement: null })
    }
}
